import AccountInfo from './account-info'

export default AccountInfo
